import Collapse from 'bootstrap/js/src/collapse';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Collapse = Collapse;
